exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".evaluation-tips{background:#f3fefd;border:1px solid #abe5dc;margin:30px 0;padding:15px}.evaluation-tips .point{font-weight:700;margin:5px 0}.evaluation-tips li{color:#333;padding:5px 0}.evaluation-tips li i{display:inline-block;width:6px;height:6px;background:#27c9b4;margin-right:10px;border-radius:100%;position:relative;top:-2px}.evaluation-tips .em{color:red}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-32046bb3","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/evaluation/society-form/society-form-tips.vue
// module id = 860
// module chunks = 23